import React, { useEffect, type FC } from 'react'

import styled from '@emotion/styled'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  Button,
  Checkbox,
  Flex,
  HelpIcon,
  SidePanelSeparator,
  TooltipUtils,
} from 'mailup-web-components'

import {
  panelAddRecipientSaveCallback,
  panelAddRecipientToggleSendConfirmationCallback,
} from 'Pages/RecipientsList/recoil/callbacks/addRecipient'
import {
  panelAddRecipientCanAddState,
  panelAddRecipientState,
} from 'Pages/RecipientsList/recoil/state/addRecipient'

const StyledFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: #fff;
`

const StyledLeft = styled(Flex)`
  border-radius: 4px 0 0 4px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--java);

  color: var(--java);

  & label {
    font-size: 13px;
    font-weight: 400;
    text-transform: uppercase;
  }
`

const StyledRight = styled(Button)`
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`

const StyledHelpIcon = styled(HelpIcon)`
  pointer-events: all;
  z-index: 1000;
  align-self: center;
`

const PanelAddRecipientFooter: FC = () => {
  const intl = useIntl()

  const { sendConfirmation } = useRecoilValue(panelAddRecipientState)

  const canAdd = useRecoilValue(panelAddRecipientCanAddState)

  const handleToggle = useRecoilCallback(
    panelAddRecipientToggleSendConfirmationCallback,
    [],
  )

  const handleAdd = useRecoilCallback(panelAddRecipientSaveCallback, [])

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    }, 1500)
  }, [])

  return (
    <StyledFooter>
      <SidePanelSeparator />
      <Flex justifyContent="end" padding="16px 32px">
        <StyledLeft
          alignItems="center"
          height="36px"
          padding="0 16px"
          gap="16px"
          data-mu-test="add-recipient__send-confirmation"
        >
          <Checkbox
            checked={sendConfirmation}
            value="true"
            onChange={handleToggle}
            label={intl.formatMessage({
              id: 'Load.RecipientsList.ActionSendConfirmationEmail',
            })}
          />
          <StyledHelpIcon
            data-tip={intl.formatMessage(
              {
                id: 'Load.RecipientsList.AddSendConfirmationEmailTip',
              },
              {
                PATHSEP: '>',
              },
            )}
          />
        </StyledLeft>

        <StyledRight
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test="add-recipient__add"
          disabled={!canAdd}
          onClick={handleAdd}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Add' })}
        </StyledRight>
      </Flex>
    </StyledFooter>
  )
}

export default PanelAddRecipientFooter
